<span class="mx-link-button-tooltip-container inline-flex" [matTooltip]="computedTooltip" (click)="onClick($event)">
  @if (genericRouteName) {
    <a [mxNamedRouterLink]="genericRouteName" [mxNamedRouterLinkParams]="routeParams" [mxQueryParams]="queryParams"
       [mxNamedRouterLinkEnabled]="enabled" [attr.aria-disabled]="computedAriaDisabled" [attr.tabindex]="computedTabIndex"
       class="mx-link-button-component">
      <ng-container [ngTemplateOutlet]="buttonContent.content" [ngTemplateOutletContext]="buttonContentContext"/>
    </a>
  } @else if (href) {
    <a [attr.href]="computedHref" [attr.target]="externalLinkTarget" [attr.rel]="externalLinkRelationship"
       [attr.aria-disabled]="computedAriaDisabled" [attr.tabindex]="computedTabIndex" class="mx-link-button-component">
      <ng-container [ngTemplateOutlet]="buttonContent.content" [ngTemplateOutletContext]="buttonContentContext"/>
    </a>
  } @else {
    <button [type]="type" [disabled]="!enabled" class="mx-link-button-component">
      <ng-container [ngTemplateOutlet]="buttonContent.content" [ngTemplateOutletContext]="buttonContentContext"/>
    </button>
  }
</span>

<mx-rectangular-button-content #buttonContent/>
